export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0"},{"http-equiv":"content-language","content":"en"},{"name":"keywords","content":"Nusatrip,online travel,travel agent,online booking,airline ticket, plane ticket, hotel nights,flights,rooms,holiday,trip,vacation,indonesia,singapore,malaysia,australia,china,hong kong,asia,europe,hotel,cheap flight,cheap tickets,cheap rates,domestic flight,international flight,promo rate,lionair,garuda,batavia,Merpati,Sriwijaya,singapore airline"},{"name":"description","content":"Nusatrip.com Online Travel - Cheap Hotels & Flights bookings - domestic & international. 200,000 hotels worldwide. compare 500 airlines- 24/7 fast booking !"},{"name":"google-site-verification","content":""}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"}],"style":[],"script":[{"type":"text/javascript","src":"https://www.nusatravelhub.com/static/js/byteSeo.js"},{"type":"text/javascript","src":"https://www.nusatravelhub.com/static/js/skyscanner.js"},{"type":"text/javascript","src":""},{"type":"text/javascript","src":"https://www.nusatravelhub.com/static/js/midtrans-new-3ds.min.js","id":"midtrans-script","data-environment":"production","data-client-key":"Mid-client-I9ay-qdhSdIeid51"}],"noscript":[{"innerHTML":"<iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-WNF4LC\" height=\"0\" width=\"0\"\n      style=\"display:none;visibility:hidden\"></iframe>"}],"charset":"utf-8","title":"Flights & Hotels - Online travel - domestic & international - Cheap Prices"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'